import { PrinterOutlined } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import { FC } from 'react'
import useErrorModal from '../../../../hooks/api/use-error-modal'
import useSuccessModal from '../../../../hooks/api/use-success-modal'
import { useCreateShipmentScheduleJobsMutation } from '../../../../store/api/shipments-api'
import Shipment from '../../../../types/api/shipment'
import { isShipmentAwaitingCuratorApproval } from '../../../../helpers/entities/shipment/curator-approval'
import { isShipmentStarted } from '../../../../helpers/entities/shipment/is-shipment-started'

interface AddShipmentToCommonScheduleQueueProps {
    shipment: Shipment
}

const AddShipmentToCommonScheduleQueue: FC<AddShipmentToCommonScheduleQueueProps> = ({
    shipment,
}) => {
    const [createScheduleJobs, createScheduleJobsState] = useCreateShipmentScheduleJobsMutation()

    const alreadySentToPrint = Boolean(shipment.print_job)
    const notStarted = !isShipmentStarted(shipment)
    const awaitingApproval = isShipmentAwaitingCuratorApproval(shipment)
    const isLoading = createScheduleJobsState.isLoading
    const disabled = alreadySentToPrint || notStarted || awaitingApproval || isLoading

    const onClick = () => {
        createScheduleJobs(shipment.documentId)
    }

    useErrorModal(createScheduleJobsState, 'Ошибка создания заданий печати и перемотки')
    useSuccessModal(createScheduleJobsState, 'Задания печати и перемотки созданы')

    const tooltipTitle = alreadySentToPrint
        ? 'Отгрузка уже в очереди печати'
        : notStarted
          ? 'Сначала запустите отгрузку'
          : awaitingApproval
          ? 'Ожидается согласование задания куратором'
          : 'Отправить в печать'

    return (
        <Tooltip title={tooltipTitle}>
            <span>
                <Button
                    size={'small'}
                    color={'blue'}
                    variant={'solid'}
                    icon={<PrinterOutlined />}
                    onClick={onClick}
                    loading={isLoading}
                    disabled={disabled}
                />
            </span>
        </Tooltip>
    )
}

export default AddShipmentToCommonScheduleQueue
